/**
 * Runtime configuration, sourced from Vite env (VITE_* → import.meta.env).
 * Mirrors v1's Settings.ts: the Core GraphQL endpoint is BASE_URL + the graphql path.
 */
const BASE_URL = import.meta.env.VITE_BASEURL || 'https://core.create2stay.com'

export const GRAPHQL_URL = BASE_URL + (import.meta.env.VITE_C2S_GRAPHQL_URL || '/api/graphql')

/**
 * Catalogue search endpoint. v2 uses `tradeinsearch2` — a GET keyed on `shopId` (the brand
 * house is resolved from the shop server-side) that returns a `{ items, facets, paging }`
 * envelope. Items carry `masterVariantId` (new masterdata, C2S-754), `image`, and a `category`.
 * Called unauthenticated. See `search/searchClient.ts`.
 */
export const SEARCH_URL = BASE_URL + (import.meta.env.VITE_C2S_SEARCH_URL || '/internal/tradeinsearch2')

/**
 * Core's image server (mirrors v1's `ImageServerUrl`). A category's `iconId` (a MongoID) resolves
 * to a hosted image at `${IMAGE_URL}/${iconId}` — used for the "add by category" tiles.
 */
export const IMAGE_URL = BASE_URL + (import.meta.env.VITE_IMAGESERVER || '/api/photo')

/** Build the hosted URL for a category icon (or any image server object) from its MongoID. */
export function imageUrl(imageId?: string | null): string | undefined {
  return imageId ? `${IMAGE_URL}/${imageId}` : undefined
}

/**
 * Local-dev convenience: our storefront harness can set `tradeInConfig.accessToken = 'demo-token'`.
 * When that exact value is present we seed a mock authenticated session instead of calling
 * Core, so the UI is developable offline. Any other token runs the real ConsumerLogin flow.
 */
export const DEV_DEMO_TOKEN = 'demo-token'
